// extracted by mini-css-extract-plugin
module.exports = {"title":"menu-item-module--title--2Bmis","menuItem":"menu-item-module--menuItem--3xDKn"};